import React from 'react';
import DeleteIcon from '@mui/icons-material/Delete';
import IconButton from '@mui/material/IconButton';

interface Props {
  onExecute: () => void;
}

function DeleteButton({ onExecute }: Props) {
  return (
    <IconButton
      onClick={() => {
        // eslint-disable-next-line
        if (window.confirm('Möchten Sie diese Zeile wirklich löschen?')) {
          onExecute();
        }
      }}
      title="Zeile löschen"
    >
      <DeleteIcon />
    </IconButton>
  );
}

export default DeleteButton;
